/* eslint-disable */
/* tslint:disable */
import createApp from '/var/www/src/main';
export { createApp };

if (process.client) {

}
import { UVue } from '@uvue/core';
import uvueConfig from '/var/www/uvue.config';

const { plugins } = uvueConfig;
for (const index in plugins) {
  if (typeof plugins[index] === 'string') {
    plugins[index] = [plugins[index], {}];
  }
}
      
const plugin0 = require('@uvue/core/plugins/vuex');
UVue.use(plugin0.default || plugin0, plugins[0][1]);
        
const plugin1 = require('/src/shared/plugins/uvue/async-data.ts');
UVue.use(plugin1.default || plugin1, plugins[1][1]);
        
const plugin2 = require('@uvue/core/plugins/prefetch');
UVue.use(plugin2.default || plugin2, plugins[2][1]);
        
const plugin3 = require('@uvue/core/plugins/middlewares');
UVue.use(plugin3.default || plugin3, plugins[3][1]);
        
const plugin4 = require('@uvue/core/plugins/errorHandler');
UVue.use(plugin4.default || plugin4, plugins[4][1]);
        
const plugin5 = require('/src/shared/plugins/uvue/init-setup.ts');
UVue.use(plugin5.default || plugin5, plugins[5][1]);
        
const plugin6 = require('/src/shared/plugins/uvue/error-clear.ts');
UVue.use(plugin6.default || plugin6, plugins[6][1]);
        
const plugin7 = require('/src/shared/plugins/uvue/progress-bar.ts');
UVue.use(plugin7.default || plugin7, plugins[7][1]);
        